import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "placeholder", "filename", "preview", "previewImage", "dropzone", "removeFlag"]

  static values = {
    multiple: { type: Boolean, default: false },
    filesSelectedTemplate: String
  }

  open (event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  remove (event) {
    event.preventDefault()
    event.stopPropagation()

    this.inputTarget.value = ""

    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "1"
    }

    if (this.hasPreviewImageTarget) {
      this.previewImageTarget.removeAttribute("src")
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }

    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove("hidden")
    }

    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = ""
      this.filenameTarget.classList.add("hidden")
    }

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }
  }

  select (event) {
    const files = event.target.files
    if (!files || files.length === 0) return

    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "0"
    }

    if (this.multipleValue) {
      this.filenameTarget.textContent = this.filesSelectedTemplateValue.replace("__COUNT__", files.length)
    } else {
      this.filenameTarget.textContent = files[0].name
    }

    this.filenameTarget.classList.remove("hidden")

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }

    if (!this.multipleValue) {
      this.showPreview(files[0])
    }
  }

  showPreview (file) {
    if (!file.type.startsWith("image/")) return

    const reader = new FileReader()
    reader.onload = (event) => {
      if (this.hasPreviewImageTarget) {
        this.previewImageTarget.src = event.target.result
      }

      if (this.hasPreviewTarget) {
        this.previewTarget.classList.remove("hidden")
      }

      if (this.hasDropzoneTarget) {
        this.dropzoneTarget.classList.add("hidden")
      }
    }
    reader.readAsDataURL(file)
  }
}
